import React from 'react';
import { motion } from 'framer-motion';
interface PawPrintProps {
  className?: string;
  delay?: number;
}
export function PawPrint({
  className = '',
  delay = 0
}: PawPrintProps) {
  return <motion.svg initial={{
    opacity: 0,
    scale: 0.5
  }} whileInView={{
    opacity: 0.15,
    scale: 1
  }} viewport={{
    once: true
  }} transition={{
    delay,
    duration: 0.5
  }} className={`text-warmBrown ${className}`} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-120">
      <path d="M12 8.5C13.933 8.5 15.5 6.933 15.5 5C15.5 3.067 13.933 1.5 12 1.5C10.067 1.5 8.5 3.067 8.5 5C8.5 6.933 10.067 8.5 12 8.5Z" data-id="element-121" />
      <path d="M6.5 12C8.433 12 10 10.433 10 8.5C10 6.567 8.433 5 6.5 5C4.567 5 3 6.567 3 8.5C3 10.433 4.567 12 6.5 12Z" data-id="element-122" />
      <path d="M17.5 12C19.433 12 21 10.433 21 8.5C21 6.567 19.433 5 17.5 5C15.567 5 14 6.567 14 8.5C14 10.433 15.567 12 17.5 12Z" data-id="element-123" />
      <path d="M12 10.5C9.5 10.5 7 12.5 6 15.5C5.16667 18 6.5 22.5 12 22.5C17.5 22.5 18.8333 18 18 15.5C17 12.5 14.5 10.5 12 10.5Z" data-id="element-124" />
    </motion.svg>;
}